export const GET_TEMPLATE_EXPERIENCES = "GET_TEMPLATE_EXPERIENCES";
export const RESET_TEMPLATE_EXPERIENCES = "RESET_TEMPLATE_EXPERIENCES";
export const SET_TEMPLATE_EXPERIENCES_REQUEST_STATUS = "SET_TEMPLATE_EXPERIENCES_REQUEST_STATUS";
